import { get } from 'lodash';

export const getEnvironmentState = () => {
	const metaLayer = window.metaLayer || window._metaLayer;

	return {
		metaLayer: {
			device_deviceClass: get(metaLayer, 'device_deviceClass', ''),
			env_assets: get(metaLayer, 'env_assets', ''),
			env_falcor: get(metaLayer, 'env_falcor', '')
		}
	};
};



// WEBPACK FOOTER //
// ./client/state-helpers.js